import { modalClose, modalOpen } from '../utils';

const YtModal = {
  openedModal: null,
  init() {
    const triggers = document.querySelectorAll<HTMLElement>('[data-yt-id]');
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const headTag = document.querySelector<HTMLHeadElement>('head');
    headTag?.insertAdjacentElement('beforeend', tag);

    if (triggers.length) {
      triggers.forEach((el) => {
        el.addEventListener('click', () => {
          if (el.dataset.ytId != undefined) {
            createModal(el.dataset.ytId);
          }
        });
      });
    }
  },
  resize() {
    if (this.openedModal != null) {
    }
  },
};
const createModal = async (ytId: string) => {
  // Modal Base Dom
  const modal = document.createElement('div');
  const modalOverlay = document.createElement('div');
  const modalContainer = document.createElement('div');
  const modalYt = document.createElement('div');
  const modalMovie = document.createElement('div');

  // Modal Setting
  modal.classList.add('c-modal');
  modal.insertAdjacentElement('beforeend', modalContainer);
  modal.insertAdjacentElement('beforeend', modalOverlay);

  modalOverlay.classList.add('c-modal__overlay');
  modalOverlay.setAttribute('data-mclose', '');

  modalContainer.classList.add('c-modal__container');
  modalContainer.insertAdjacentElement('beforeend', modalYt);

  modalYt.classList.add('c-modal__yt');

  modalMovie.id = 'YtMovie';
  modalYt.insertAdjacentElement('beforeend', modalMovie);
  // ADD Modal
  document.body.insertAdjacentElement('beforeend', modal);

  await modalOpen(modal);
  const player = onYouTubeIframeAPIReady('YtMovie', ytId);

  // Ready Close
  const closes = modal.querySelectorAll('[data-mclose]');
  if (closes.length) {
    closes.forEach((close) => {
      close.addEventListener('click', async () => {
        stopVideo(player);
        await modalClose(modal);
        modal.remove();
      });
    });
  }
};
function onPlayerReady(event: any) {
  event.target.playVideo();
}
function stopVideo(player: any) {
  player.stopVideo();
}
const onYouTubeIframeAPIReady = (id: string, ytId: string) => {
  const player = new YT.Player(id, {
    height: '390',
    width: '640',
    videoId: ytId,
    playerVars: {
      rel: 0,
      modestbranding: 1,
      autoplay: 1,
      playsinline: 1,
    },
    events: {
      onReady: onPlayerReady,
    },
  });
  return player;
};

export { YtModal };
